import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  searchText: null,
  onlyPadrao: false,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
